import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
    flex: 1,
    minHeight: 'calc(100vh - 64px)'
  }
}));


const getAccessToken = () => {
  try {
    const persistRoot = localStorage.getItem('persist:root');
    if (!persistRoot) return null;

    const parsedRoot = JSON.parse(persistRoot);

    if (!parsedRoot.auth) return null;

    const auth = JSON.parse(parsedRoot.auth);

    return auth.accessToken || null;
  } catch (err) {
    console.error('Erro ao recuperar accessToken:', err);
    return null;
  }
};

const BASE_URL = 'https://gerencia-new.construrapi.cloud';
const ANALYTICS_TOKEN = '2161467ae0386e951345953d6c12dc1f22c22bade1acbfff76ff6a5aaf86c24b';

const DashboardIframe = ({ path, title }) => {
  const classes = useStyles();
  const accessToken = getAccessToken();

  
  const url = `${BASE_URL}${path}?token=${ANALYTICS_TOKEN}&accessToken=${accessToken}`;

  return (
    <Page className={classes.root} title={title}>
      <iframe
        src={url}
        className={classes.iframe}
        title={title}
        allowFullScreen
      />
    </Page>
  );
};

DashboardIframe.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default DashboardIframe;

